/* SOFS bundle qty — el carrito no puede editar la línea fusionada del Cart Transform.
   "+" re-agrega el mismo pack (sube cantidad y precio). "−"/Eliminar quita el pack.
   Listener delegado en document (capture) para que funcione con el drawer renderizado por AJAX.

   La tabla PRODUCTOS la genera scripts/_build_bundle_qty.mjs desde los productos
   asignados al rack de la landing — NO editarla a mano. */
(function () {
  if (window.__sofsBundleQtyBound) return;
  window.__sofsBundleQtyBound = true;

  /* Título del producto, color base (en español, sin acentos), versión y variant
     id por talla. Generado desde el theme. */
  var PRODUCTOS = [
    /* Polos (la landing de polos usa el mismo carrito) */
    {"titulo":"Country Club Slim Polo — Grey","color":"gris","version":1,"tallas":{"XS":44533341028403,"S":44484163305523,"M":44484163338291,"L":44484163371059,"XL":44484163403827,"XXL":44533341061171}},
    {"titulo":"Country Club Slim Polo — Black","color":"negro","version":1,"tallas":{"XS":44839536197683,"S":44839536230451,"M":44839536263219,"L":44839536295987,"XL":44839536328755,"XXL":44839536361523}},
    {"titulo":"Country Club Slim Polo — Navy Blue","color":"azulnavy","version":1,"tallas":{"XS":44839614840883,"S":44839614873651,"M":44839614906419,"L":44839614939187,"XL":44839614971955,"XXL":44839615004723}},
    {"titulo":"SOFS Basic Regular T-Shirt — White S","color":"blanco","version":1,"tallas":{"S":44434686378035,"M":44434686410803,"L":44434686443571,"XL":44434686476339,"XXL":44434686607411}},
    {"titulo":"SOFS Basic Regular T-Shirt — Dark Grey","color":"gris","version":1,"tallas":{"S":44434686935091,"M":44434686967859,"L":44434687000627,"XL":44434687033395,"XXL":44434687066163}},
    {"titulo":"SOFS Basic Regular T-Shirt — Black B","color":"negro","version":1,"tallas":{"S":44434686672947,"M":44434686705715,"L":44434686738483,"XL":44434686771251,"XXL":44434686804019}},
    {"titulo":"SOFS Basic Regular T-Shirt — Deep Blue","color":"azulnavy","version":1,"tallas":{"S":44434687164467,"M":44434687197235,"L":44434687230003,"XL":44434687262771,"XXL":44434687295539}},
    {"titulo":"SOFS Basic Regular T-Shirt — Sand S","color":"sand","version":1,"tallas":{"S":44434687328307,"M":44434687361075,"L":44434687393843,"XL":44434687426611,"XXL":44434687459379}},
    {"titulo":"SOFS Basic Regular T-Shirt — White G","color":"blanco","version":2,"tallas":{"S":44724684816435,"M":44724684849203,"L":44724684881971,"XL":44724684914739,"XXL":44724684947507}},
    {"titulo":"SOFS Basic Regular T-Shirt — Deep Grey","color":"gris","version":2,"tallas":{"S":44724689109043,"M":44724689141811,"L":44724689174579,"XL":44724689207347,"XXL":44724689240115}},
    {"titulo":"SOFS Basic Regular T-Shirt — Black G","color":"negro","version":2,"tallas":{"S":44724681703475,"M":44724681736243,"L":44724681769011,"XL":44724681801779,"XXL":44724681834547}},
    {"titulo":"SOFS Basic Regular T-Shirt — Navy Blue","color":"azulnavy","version":2,"tallas":{"S":44724688748595,"M":44724688781363,"L":44724688814131,"XL":44724688846899,"XXL":44724688879667}},
    {"titulo":"SOFS Basic Regular T-Shirt — Sand W","color":"sand","version":2,"tallas":{"S":44724689502259,"M":44724689535027,"L":44724689567795,"XL":44724689600563,"XXL":44724689633331}},
    {"titulo":"SOFS Basic Regular T-Shirt — Cream","color":"crema","version":2,"tallas":{"S":44724687700019,"M":44724687732787,"L":44724687765555,"XL":44724687798323,"XXL":44724687831091}}
  ];

  var PACK_BY_COUNT = {1:"one",2:"two",3:"tree",5:"five"};
  /* Los polos son otra familia de packs: la Function les cobra con otras llaves.
     Se reconocen por la variante del contenedor de la línea del carrito. */
  var PARENT_POLOS = 44834408857651;
  var PACK_BY_COUNT_POLOS = {1:"polo_one",2:"polo_two",3:"polo_tree"};
  function mapaDe(it) {
    return Number(it && it.variant_id) === PARENT_POLOS ? PACK_BY_COUNT_POLOS : PACK_BY_COUNT;
  }

  /* Colores en inglés de los títulos viejos → el color base del rack. */
  var ALIAS = {white:"blanco",black:"negro",grey:"gris",gray:"gris",darkgrey:"gris",deepgrey:"gris",
               navyblue:"azulnavy",deepblue:"azulnavy",navy:"azulnavy",arena:"sand",cream:"crema"};

  function norm(s) {
    return String(s || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      .toLowerCase().replace(/[^a-z0-9]/g, '');
  }

  /* Resuelve el variant id desde lo que se ve en el carrito ("Camiseta N").
     Hoy la landing manda "<título del producto> · V1 / TALLA"; los carritos
     armados antes traen "Blanco · V1 / TALLA" o "White / TALLA", así que hay un
     respaldo por color + versión. */
  function resolver(valor) {
    var v = String(valor || '');
    var i = v.lastIndexOf('/');
    if (i < 0) return null;
    var talla = v.slice(i + 1).trim().toUpperCase();
    var n = norm(v.slice(0, i));
    if (!n || !talla) return null;

    for (var a = 0; a < PRODUCTOS.length; a++) {
      if (n.indexOf(norm(PRODUCTOS[a].titulo)) === 0) return PRODUCTOS[a].tallas[talla] || null;
    }

    var m = n.match(/^(.*?)v([12])$/);
    var color = ALIAS[m ? m[1] : n] || (m ? m[1] : n);
    var ver = m ? Number(m[2]) : 0;
    var cands = PRODUCTOS.filter(function (p) { return p.color === color && (!ver || p.version === ver); })
                         .sort(function (p, q) { return p.version - q.version; });
    for (var b = 0; b < cands.length; b++) { if (cands[b].tallas[talla]) return cands[b].tallas[talla]; }
    return null;
  }

  /* ---------- +/− / Eliminar de la línea del pack ----------

     El Cart Transform crea UNA línea por grupo de camisetas y esa línea no se
     puede editar: probado en vivo, /cart/change.js con su key responde 200 y no
     cambia nada, y volver a agregar las mismas camisetas con el mismo
     _sofs_pack_id se descarta en silencio. O sea que "2 packs" son dos líneas
     reales, sí o sí; el carrito las junta visualmente en el snippet
     cart-line-items.liquid (en el servidor, para que no se vea el duplicado) y
     deja las keys del grupo en data-sofs-keys.

     Acá: "+" agrega otro pack, "−" quita una línea del grupo y "Eliminar" quita
     todas. */

  var AVISO_STOCK = 'No alcanzó el inventario para repetir el pack.';

  /* Aviso corto dentro de la línea del carrito (rosado, se va solo). */
  function aviso(nodo, texto) {
    if (!nodo) { alert(texto); return; }
    var p = nodo.querySelector('.sofs-aviso');
    if (!p) {
      p = document.createElement('p');
      p.className = 'sofs-aviso';
      p.setAttribute('style', 'margin:6px 0 0;font-size:10.5px;line-height:1.35;letter-spacing:.02em;color:#e8a0c0');
      nodo.appendChild(p);
    }
    p.textContent = texto;
    clearTimeout(p._sofsT);
    p._sofsT = setTimeout(function () { if (p.parentNode) p.parentNode.removeChild(p); }, 6000);
  }

  var num = function (k) { return parseInt(String(k).replace(/\D+/g, ''), 10) || 0; };

  /* Las camisetas del pack son las propiedades visibles ("Camiseta 1"…): el
     nombre lo pone el Cart Transform y el prefijo es editable en el editor, así
     que se filtra por "no empieza con _" y se ordena por el número. */
  function camisetas(props) {
    return Object.keys(props || {}).filter(function (k) { return k.charAt(0) !== '_'; })
                 .sort(function (a, b) { return num(a) - num(b); });
  }

  /* Las keys de las líneas del grupo (la primera es la visible). */
  function keysDe(nodo) {
    var attr = nodo.getAttribute('data-sofs-keys');
    return attr ? attr.split(',') : [nodo.getAttribute('data-item')];
  }

  function quitarTodos(keys) {
    return keys.reduce(function (p, k) {
      return p.then(function () {
        return fetch('/cart/change.js', {
          method: 'POST', headers: {'Content-Type': 'application/json'},
          body: JSON.stringify({ id: k, quantity: 0 })
        });
      });
    }, Promise.resolve()).then(refresh);
  }

  function refresh() {
    var ce = document.querySelector('cart-element');
    if (ce && ce.getCart) { try { ce.getCart(); } catch (e) {} }
    else { try { location.reload(); } catch (e) {} }
  }

  // Cada pack es una línea separada (_grp único en la Function) → se quita por su key.
  function removeLine(key) {
    return fetch('/cart/change.js', {
      method: 'POST', headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({ id: key, quantity: 0 })
    }).then(refresh);
  }

  function readd(key, nodo) {
    return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var it = cart.items.filter(function (i) { return i.key === key; })[0];
      if (!it) return;
      var props = it.properties || {};
      var keys = camisetas(props);
      var mapa = mapaDe(it);
      var packKey = mapa[keys.length];
      /* Sin llave para esa cantidad no se re-agrega: cobraría el precio de otro pack. */
      if (!packKey) return;
      var group = 'pkreadd_' + (window.performance ? Math.round(performance.now()) : 0) + '_' + keys.length;
      var items = [], idx = 0, fallidas = 0;
      keys.forEach(function (k) {
        idx++;
        var val = String(props[k] || '');
        var vid = resolver(val);
        if (!vid) { fallidas++; return; }
        items.push({ id: Number(vid), quantity: 1, properties: {
          '_sofs_pack': packKey, '_sofs_pack_id': group, '_sofs_idx': String(idx),
          '_sofs_sel': val, '_sofs_img': props['_img_' + num(k)] || ''
        }});
      });
      /* Si alguna no se pudo resolver, no se agrega un pack incompleto: se cobraría
         el precio del pack entero con menos camisetas. */
      if (!items.length || fallidas) return;
      return fetch('/cart/add.js', {
        method: 'POST', headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        return r.json().catch(function () { return null; });
      }).then(function (data) {
        /* El carrito responde 200 con quantity 0 cuando no alcanza el inventario:
           no se agregó nada, así que se avisa y no se re-renderiza (si no, el
           aviso se iría con el re-render). */
        var rechazado = data && data.items && data.items.length &&
                        data.items.every(function (i) { return Number(i.quantity) === 0; });
        if (rechazado) { aviso(nodo, AVISO_STOCK); return; }
        refresh();
      });
    });
  }

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var item = e.target.closest('[data-sofs-bundle]');
    if (!item) return;
    var isRemove = e.target.closest('[data-item-remove]');
    var isMinus = e.target.closest('[data-quantity-minus]');
    var isPlus = e.target.closest('[data-quantity-plus]');
    if (!isRemove && !isMinus && !isPlus) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var keys = keysDe(item);
    if (isPlus) { readd(keys[0], item); }
    else if (isMinus) { removeLine(keys[keys.length - 1]); }  // un pack menos, no todos
    else { quitarTodos(keys); }
  }, true);

})();
